import { render, staticRenderFns } from "./Home_new.vue?vue&type=template&id=ce39a81c&scoped=true"
import script from "./Home_new.vue?vue&type=script&lang=js"
export * from "./Home_new.vue?vue&type=script&lang=js"
import style0 from "./Home_new.vue?vue&type=style&index=0&id=ce39a81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce39a81c",
  null
  
)

export default component.exports